import Vue from 'vue'
import Router from 'vue-router'

import Home from './pages/Home'
import Exercise from './pages/Exercise'
import Help from './pages/Help'
import HelpMenu from './components/HelpMenu'
import Privacy from './pages/Privacy'
import Terms from './pages/Terms'
import License from './pages/License'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/exercise',
      name: 'exercise',
      component: Exercise
    },
    {
      path: '/help',
      name: 'help',
      component: Help
    },
    {
      path: '/app/help',
      name: 'appHelp',
      component: HelpMenu
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy
    },
    {
      path: '/terms',
      name: 'terms',
      component: Terms
    },
    {
      path: '/license',
      name: 'license',
      component: License
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) { return savedPosition } else { return { x: 0, y: 0 } }
  }
  
})
router.beforeEach((to, from, next) => {
  next()
})


export default router
